import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';

import { Currency } from '../../shared/currency.model';
import { CurrencyService } from '../../shared/currency.service';

@Component({
  selector: 'app-currency-translation-modal',
  templateUrl: './currency-translation-modal.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class CurrencyTranslationModalComponent {
  constructor(
    private currencyService: CurrencyService,
    private ref: MatDialogRef<CurrencyTranslationModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getCurrency();
  }

  currency: Currency = null;

  modalTitle = this.data.title;
  currencyId = this.data.obj.id;
  language = this.data.params.language;

  close() {
    this.ref.close();
  }

  private getCurrency() {
    let params = {
      get: 'translate',
      lang: this.language.lang,
    };

    this.currencyService.getCurrency(this.currencyId, params).subscribe((currency) => {
      this.currency = currency;
    });
  }
}
